// extracted by mini-css-extract-plugin
export default {"pagination__wrapper":"styles_pagination__wrapper__DMwIQ","pagination__container":"styles_pagination__container__qSR4h","table__container":"styles_table__container__Tyz2c"};